<template>
  <div>
		<div class="slider">
			<b-carousel
				id="carousel-fade"
				style="text-shadow: 0px 0px 2px #000"
				fade
				controls
				img-width="1024"
				img-height="480"
			>
				<b-carousel-slide
					img-src="/img/slider/slide1.png"
				>
					<div class="btn-slider d-flex flex-wrap align-items-center justify-content-center">
						<!-- <a href="#" class="book-now-btn mx-2">Panduan Penggunaan</a>
						<a href="#" class="book-now-btn mx-2">Penggunaan Penyelenggaraan</a> -->
					</div>
				</b-carousel-slide>
				<b-carousel-slide
					img-src="/img/slider/slide2.png"
				>
					<div class="btn-slider d-flex flex-wrap align-items-center justify-content-center">
						<!-- <a href="#" class="book-now-btn mx-2">Panduan Penggunaan</a>
						<a href="#" class="book-now-btn mx-2">Penggunaan Penyelenggaraan</a> -->
					</div>
				</b-carousel-slide>
				<b-carousel-slide
					img-src="/img/slider/slide3.png"
				>
					<div class="btn-slider d-flex flex-wrap align-items-center justify-content-center">
						<!-- <a href="#" class="book-now-btn mx-2">Panduan Penggunaan</a>
						<a href="#" class="book-now-btn mx-2">Penggunaan Penyelenggaraan</a> -->
					</div>
				</b-carousel-slide>
			</b-carousel>
		</div>
		<div id="package" class="package">
			<h6 style="text-align: center; font-size: 14px;"><strong>Untuk melanjutkan, silakan pilih program yang diikuti:</strong></h6>
			<div class="d-flex flex-wrap align-items-center justify-content-center">
				<div class="card" @click="showModalLogin">
					<div class="card-body">
						<div class="icon-package">
							<archive-icon size="4x" class="custom-class card-book-icon"></archive-icon>
						</div>
						<div class="package-name">
							<h5>Paket A</h5>
						</div>
						<div class="package-desc px-lg-3">
							<span>Paket A merupakan program layanan pendidikan kesetaraan pada jenjang pendidikan dasar setara dengan SD</span>
						</div>
					</div>
				</div>
				<div class="card" @click="showModalLogin">
					<div class="card-body">
						<div class="icon-package">
							<archive-icon size="4x" class="custom-class card-book-icon"></archive-icon>
						</div>
						<div class="package-name">
							<h5>Paket B</h5>
						</div>
						<div class="package-desc px-lg-3">
							<span>Paket B merupakan program layanan pendidikan kesetaraan pada jenjang pendidikan dasar lanjutan setara SMP</span>
						</div>
					</div>
				</div>
				<div class="card" @click="showModalLogin">
					<div class="card-body">
						<div class="icon-package">
							<archive-icon size="4x" class="custom-class card-book-icon"></archive-icon>
						</div>
						<div class="package-name">
							<h5>Paket C</h5>
						</div>
						<div class="package-desc px-lg-3">
							<span>Paket C merupakan program layanan pendidikan kesetaraan pada jenjang pendidikan menengah setara SMA</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div id="package" class="package">
			<h6 style="text-align: center; font-size: 14px;"><strong>Untuk melanjutkan, silakan pilih program yang diikuti:</strong></h6>
			<div class="d-flex flex-wrap align-items-center justify-content-center">
				<div class="card" @click="showModalLogin">
					<div class="card-body">
						<div class="icon-gallery">
							<archive-icon size="4x" class="custom-class card-book-icon"></archive-icon>
						</div>
						<div class="package-name">
							<h5>Galery</h5>
						</div>
						<div class="package-desc px-lg-3">
							<span>Galery Foto</span>
						</div>
					</div>
				</div>
				<div class="card" @click="showProfilePage">
					<div class="card-body">
						<div class="icon-package">
							<archive-icon size="4x" class="custom-class card-book-icon"></archive-icon>
						</div>
						<div class="package-name">
							<h5>Profil</h5>
						</div>
						<div class="package-desc px-lg-3">
							<span>Profil</span>
						</div>
					</div>
				</div>
				<div class="card" @click="showModalLogin">
					<div class="card-body">
						<div class="icon-package">
							<archive-icon size="4x" class="custom-class card-book-icon"></archive-icon>
						</div>
						<div class="package-name">
							<h5>Program </h5>
						</div>
						<div class="package-desc px-lg-3">
							<span>Program Belajar merupakan program layanan pendidikan kesetaraan pada jenjang pendidikan yang setara dengan SD, SMP, dan SMA</span>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="data-jumlah">
			<div class="d-flex flex-wrap align-items-center justify-content-center">
				<div class="card">
					<div class="card-body">
						<h1>{{totalUser.total_user}}</h1>
					</div>
					<div class="card-footer p-3">
						<p><users-icon size="1.5x" class="custom-class"></users-icon> USER</p>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<h1>{{totalUser.total_tutor}}</h1>
					</div>
					<div class="card-footer p-3">
						<p><users-icon size="1.5x" class="custom-class"></users-icon> TUTOR</p>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<h1>{{totalUser.total_murid}}</h1>
					</div>
					<div class="card-footer p-3">
						<p><users-icon size="1.5x" class="custom-class"></users-icon> WARGA BELAJAR</p>
					</div>
				</div>
			</div>
		</div>
		<div>
			<b-modal
				ref="login-modal"
				class="login-model"
				size="md"
				hide-footer
				hide-header
				no-close-on-backdrop
			>
			<login-form></login-form>
			</b-modal>
		</div>
  </div>
</template>

<script>
	import LoginForm from "../../components/Main/LoginForm";
	import { ArchiveIcon } from 'vue-feather-icons'
	import { UsersIcon } from 'vue-feather-icons'
    import { EventBus } from '@/eventBus.js'
	import { mapGetters } from 'vuex'
	export default {
		components: {
			ArchiveIcon,
			LoginForm,
			UsersIcon
		},
		data() {
			return {
				showLoader: false
			}
		},
		computed: {
			...mapGetters({
				totalUser: 'getTotalUser',
			})
		},
		methods: {
			showModalLogin() {
				this.$refs['login-modal'].show()
			},
			showProfilePage() {
				// this.$router.replace('/profile')
				this.$router.push({ name: 'profile-page-child'  })
			},
			hideModalLogin() {
				this.$refs['login-modal'].hide()
			},
			getTotalUser () {
				EventBus.$emit('showLoader', true)
				this.$store.dispatch('getTotalUser')
					.then(() => {
						EventBus.$emit('hideLoader', true)
					})
					.catch((err)=> {
						EventBus.$emit('hideLoader', true)
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			}
		},
		created () {
			EventBus.$on('hideModalLogin', (val) => {
				if (val) {
					this.hideModalLogin()
				}
			})
            EventBus.$on('scrollToPackage', (val) => {
                if (val) {
					this.$scrollTo('#package')
                }
            })
			this.getTotalUser()
		}
	}
</script>
<style lang="css" scoped>
.btn-slider {
  margin-bottom: 50px;
}
.package, .data-jumlah {
	padding: 50px;
	padding-bottom: 0px;
}
.data-jumlah {
	padding-top: 25px;
}
.card-book-icon {
	color: #6d0101;
}
/* .card-book-icon:hover {
	color: white;
} */
.package-name {
	margin-top: 15px;
	margin-bottom: 15px;
}
.package-name h5 {
	color: black;
	font-weight: bold;
}
/* .package-name h5:hover {
	color: white;
} */
.package .card, .data-jumlah .card {
	margin: 25px;
	width: 300px;
	height: auto;
	text-align: center;
}
.package .card {
	cursor: pointer;
	min-height: 150px;
}
.package-desc {
	color: #707070;
	text-align: justify;
}
.package .card:hover {
	background-color: #6d0101;
}
.data-jumlah .card {
	color: #707070;
}
.data-jumlah .card .card-body h1 {
	color: #6d0101;
}
.data-jumlah .card .card-footer p {
	font-weight: 500;
}
.data-jumlah .card:hover {
	border: 5px solid #6d0101;
}
.package .card:hover h5{
	color: white !important;
}
.package .card:hover .card-book-icon {
	color: white !important;
}
.package .card:hover .package-desc {
	color: white !important;
}
.login-form {
	padding: 25px;
}
@media (max-width:641px)  {
  .btn-slider {
    margin-bottom: 0px;
  }
  .btn-slider a {
    margin: 2px;
    font-size: 10px;
  }
}
</style>